module.exports = __webpack_public_path__ + "b56d92b231a1ae834bc3053d974474dc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-58@2x.png
// module id = 526
// module chunks = 0